import script from "./RequirementDocModal.vue?vue&type=script&setup=true&lang=js"
export * from "./RequirementDocModal.vue?vue&type=script&setup=true&lang=js"

import "./RequirementDocModal.vue?vue&type=style&index=0&id=74bb6c5f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74bb6c5f"]])

export default __exports__